var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTamnoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48709 7.93546C8.48709 3.73706 11.8498 0.333496 15.9979 0.333496C20.146 0.333496 23.5087 3.73703 23.5087 7.93546L23.5136 14.0649C23.5136 14.6103 23.9504 15.0523 24.4892 15.0523C25.028 15.0523 25.4647 14.6103 25.4647 14.0649V11.5067C25.4647 9.53435 27.0444 7.93546 28.9931 7.93546H32V14.0649C31.9999 18.2633 28.6372 21.6668 24.4892 21.6668C20.3411 21.6668 16.9783 18.2634 16.9784 14.0649L16.9734 7.93546C16.9735 7.39015 16.5367 6.94804 15.9979 6.94804C15.4591 6.94804 15.0224 7.39016 15.0223 7.93546L15.0216 14.0649C15.0216 18.2633 11.6588 21.6668 7.5108 21.6668C3.36267 21.6668 -2.37343e-05 18.2634 1.2564e-10 14.0649L0 7.93546H3.00686C4.95553 7.93546 6.53524 9.53435 6.53524 11.5067L6.53523 14.0649C6.53523 14.6103 6.97201 15.0523 7.5108 15.0523C8.04957 15.0523 8.48709 14.6103 8.48709 14.0649V7.93546Z",
    fill: "#85B32A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTamnoon);
export default __webpack_public_path__ + "static/media/Tamnoon.e819ca1d43ed69280c839fdc0aa2ba84.svg";
export { ForwardRef as ReactComponent };